var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRotateLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19,12c0,3.86-3.14,7-7,7s-7-3.14-7-7h2c0,2.76,2.24,5,5,5s5-2.24,5-5-2.24-5-5-5v2h-1l-3-3,3-3h1v2c3.86,0,7,3.14,7,7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRotateLeft);
export default __webpack_public_path__ + "static/1773309961/media/icon-rotate-left.13fb36f57009981295bbf4f169e01132.svg";
export { ForwardRef as ReactComponent };